import useDroneStore from "../../../store/droneStore";

const DroneImgViewModal = ({ imgLink }) => {
    const { setDroneImgToView } = useDroneStore((state) => state)
    return (
        <>
            <div onClick={() => { setDroneImgToView("") }} className="grid cursor-pointer place-items-center w-screen h-screen fixed z-50 bg-black/25 backdrop-blur-sm inset-0">
                <div id="defaultModal" className="p-4 overflow-x-hidden overflow-y-auto md:inset-0">
                    <div className="relative w-full max-w-6xl max-h-fit">
                        <div className="relative bg-white rounded-lg dark:bg-white" >
                            <img src={imgLink} className="h-70vh" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default DroneImgViewModal;